import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import ProjectBasedItemsWidget from '../../../widgets/projectBasedItemsWidget/ProjectBasedItemsWidget'
import '../styles.less'
import { getProjectBaseInfo } from '../../../redux/actions/projectBasedItems'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import InfomaViewWidget from '../../../widgets/infomaWidget/InfomaViewWidget'
//รายการงวดโครงการ
export default function ProjectBasedItems() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectCode = sessionGetItemStr('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectBaseInfo(projectCode)
      // console.log('gggg => ', _schema)
      setSchema(_schema)
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeAndExpense>
        <ContentHeader header={schema.model.header} subHeader={''} isNotCallApi isShowGoButton />

        <ProjectBasedItemsWidget schema={schema.model} />

        {schema.model.verifiedDocuments && (
          <>
            <InfomaViewWidget
              header={schema.model.verifiedDocuments.header}
              schema={schema.model.verifiedDocuments}
              style={{ marginTop: 20 }}
            />
          </>
        )}

        <br />
      </SidebarProposal>
    </div>
  )
}
